import { Link } from 'react-router-dom';
import { Phone } from 'lucide-react';

export default function Header({ fiduciaryName, fiduciaryPhone }) {
  return (
    <header className="bg-white border-b-4 border-[#E3000F] sticky top-0 z-50" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-3" data-testid="header-logo">
            <div className="swiss-cross" />
            <span className="font-['Chivo'] font-black text-xl text-[#111827] tracking-tight">
              {fiduciaryName || "Déclaration d'impôts"}
            </span>
          </Link>
          <div className="flex items-center gap-6">
            {fiduciaryPhone && (
              <a href={`tel:${fiduciaryPhone}`} className="hidden sm:flex items-center gap-2 text-sm font-semibold text-[#111827]" data-testid="header-phone">
                <Phone size={16} />
                {fiduciaryPhone}
              </a>
            )}
            <a
              href="#formulaire"
              className="bg-[#E3000F] text-white hover:bg-[#A6000B] px-6 py-2.5 font-bold text-sm tracking-wide transition-colors font-['IBM_Plex_Sans']"
              data-testid="header-cta"
            >
              Demander un devis
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}
